<template>
  <select-item
    :validator="validator"
    :items="selectableGroups"
    placeholder="Select a Group"
    placeholderEmpty="No other groups found"
  />
</template>

<script>
import SelectItem from "./SelectItem.vue";
import { mapGetters } from "vuex";

export default {
  name: "SelectGroup",
  components: {
    SelectItem
  },
  props: {
    validator: Object,
    excludeGroupId: String
  },
  computed: {
    ...mapGetters("group", ["groupList"]),
    selectableGroups() {
      return this.groupList.filter(group => {
        return group.id != this.excludeGroupId;
      });
    }
  }
};
</script>
